var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { STACK_DIRECTION, STACK_GAP, StackView } from "../StackView";
import { FormGroupContextProvider, useFormGroupContext } from "../FormGroupContext";
import { createUIElement } from "../helpers";
export var NoLabelGroupLayout = styled(StackView)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0;\n"], ["\n    padding: 0;\n"])));
var StyledTr = styled.tr(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: table-row;\n    padding: 0;\n    box-sizing: border-box;\n    > * > ", " > ", " {\n        padding-left: 28px;\n    }\n"], ["\n    display: table-row;\n    padding: 0;\n    box-sizing: border-box;\n    > * > ", " > ", " {\n        padding-left: 28px;\n    }\n"])), NoLabelGroupLayout, NoLabelGroupLayout);
export var NoLabelGroup = createUIElement('NoLabelGroup', function (_a, ref) {
    var className = _a.className, children = _a.children, control = _a.control, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.hidden, hidden = _c === void 0 ? false : _c, content = _a.content, subContent = _a.subContent, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "children", "control", "disabled", "hidden", "content", "subContent", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var _d = useFormGroupContext(), groupDisabled = _d.disabled, groupHidden = _d.hidden;
    if (groupHidden || hidden) {
        return null;
    }
    var cnt = content || control;
    var sub = subContent || children;
    return (React.createElement(FormGroupContextProvider, { value: { disabled: groupDisabled || disabled, hidden: hidden } },
        React.createElement(StyledTr, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-NoLabelGroup " + className, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
            React.createElement("td", { colSpan: 2 },
                React.createElement(NoLabelGroupLayout, { direction: STACK_DIRECTION.column, gap: STACK_GAP.s },
                    cnt,
                    sub && (React.createElement(NoLabelGroupLayout, { direction: STACK_DIRECTION.column, gap: STACK_GAP.s }, sub)))))));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=NoLabelGroup.js.map